// extracted by mini-css-extract-plugin
export var active = "_7f-b";
export var activeIndicator = "_7f-6";
export var animate = "_7f-a";
export var disabled = "_7f-c";
export var flat = "_7f-1";
export var fullWidth = "_7f-3";
export var lg = "_7f-9";
export var md = "_7f-8";
export var redoButtonTabGroup = "_7f-0";
export var sm = "_7f-7";
export var tabButton = "_7f-4";
export var tabButtonsContainer = "_7f-2";
export var xs = "_7f-5";